import { Tooltip } from '@clickguard/design-system'
import moment from 'moment'

export const BoostTag = ({ endsAt }: { endsAt: string }) => (
	<Tooltip
		portal
		position="bottom"
		maxWidth={300}
		content={`3x monthly ad spend protection limit through ${moment
			.utc(endsAt)
			.format('MMMM D, YYYY')}`}
	>
		<span className="inline-flex h-5 shrink-0 items-center rounded-full border border-brand bg-t-step-inactive px-2 text-[12px] font-semibold leading-4 text-[color:var(--brand-chip-ink,#3420a4)]">
			BF 3x
		</span>
	</Tooltip>
)
